/**
 * @file Column component for displaying a entity value.
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { ColumnBase } from '../column-base/column-base';
import { ColumnProvider } from '../../column-provider';
import { AlertsService } from '../../../core/alerts.service';
import { ComponentRegistry } from '../../../core/component-registry';
import { DomainService } from '../../../domain.service';
/**
 * Column component for displaying a entity value
 */
var ColumnNameComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnNameComponent, _super);
    /**
     * Constructs a ColumnEntityComponent.
     * @param provider Provides the configuration information for the column.
     * @param overlayService The router service.
     */
    function ColumnNameComponent(provider, changeDetector, domainService, alertsService) {
        var _this = _super.call(this, provider, changeDetector) || this;
        _this.domainService = domainService;
        _this.alertsService = alertsService;
        return _this;
    }
    /**
     * Register this column class for the column provider.
     */
    ColumnNameComponent.register = function () {
        ComponentRegistry.register('column', 'name', ColumnNameComponent);
    };
    ColumnNameComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getDisplayValue()];
                    case 1:
                        _a.fullName = _b.sent();
                        this.changeDetector.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns a string representation of the entity based on the field settings.
     * @returns {string} A string representation of the entity.
     */
    ColumnNameComponent.prototype.getDisplayValue = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var user, name;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUser(this.provider.value)];
                    case 1:
                        user = _a.sent();
                        name = user['FirstName'] + " " + user['Name'];
                        return [2 /*return*/, Promise.resolve(name)];
                }
            });
        });
    };
    ColumnNameComponent.prototype.getUser = function (oid) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var entityType, user;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entityType = this.domainService.getEntityType('Resource');
                        return [4 /*yield*/, this.domainService.getEntityByKey(entityType, oid).toPromise()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, user];
                }
            });
        });
    };
    return ColumnNameComponent;
}(ColumnBase));
export { ColumnNameComponent };
